import { scrollbarStyle } from '@styles/variants/scrollbar';
import styled from 'styled-components';

const Scrollbar = styled.div<{ maxheight?: number }>`
  display: flex;
  flex-direction: column;
  height: fit-content !important;
  max-height: ${({ maxheight }) => maxheight && `${maxheight}px`};

  > div:first-child {
    position: relative !important;
    height: fit-content;
    max-height: ${({ maxheight }) => maxheight && `${maxheight}px`};
  }
  ${scrollbarStyle}
`;

export default Scrollbar;
